import { Vehicle } from 'src/modules/shared/models/vehicle';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable, pipe, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TCCPHttpService } from '../shared/services/tccp-http.service';
import { TCCPConstantValues } from '../shared/models/tccp-constants';
import { TCCPLoggerService } from '../shared/services/tccp-logger.service';
import { environment } from '../../environments/environment';
import { Flow } from '../shared/models/Flow';
import { Content } from '../shared/models/content';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { LoaderService } from '../shared/loader/loader.service';
import { ContentData } from '../shared/models/content-data';

@Injectable({
    providedIn: 'root'
})
export class AdminService {

    constructor(
        private httpService: TCCPHttpService, private logger: TCCPLoggerService, private http: HttpClient,
        private loaderService: LoaderService) { }
    public navigateToFlow = new EventEmitter();
    public navigateToFeature = new EventEmitter();
    public refreshToVehicle = new EventEmitter();
    public refreshDashboard = new EventEmitter();
    public refreshDraftFeatures = new EventEmitter();
    public modelFilterEmmiter = new EventEmitter();
    public classificationFilterEmmiter = new EventEmitter();
    public yearFilterEmmiter = new EventEmitter();
    public generationFilterEmmiter = new EventEmitter();
    public refreshFeatureTreeEmitter = new EventEmitter();
    public editModeNavigation = new EventEmitter();
    public closeFeatureExpansionPanel = new EventEmitter();
    public switchApp = false;
    public addStepClicked = false;
    public controlList: any = [];
    public controlInformation: any = {};
    public yearList: any = [];
    public generationList: any = [];

    public yearFilter: string[] = [];
    public generationFilter: string[] = [];
    public modelFilter: string[] = [];
    public classificationFilter: string[] = [];
    public vehicleList: Vehicle[] = [];
    public filterdModelList: Vehicle[] = [];
    public vehicleFilteredList: Vehicle[] = [];
    public vehicleClassification: string[] = [];
    public apiUrl: string;
    public selectedApplication: string = '';
    public isStepInViewMode = false;
    public isFeatureInViewMode = false;
    public appBase = TCCPConstantValues[environment.applicationName];
    public baseURL = this.appBase.Urls;
    public selectedStepIssueId: string = '';
    public selectedFeatureTargetId: string = '';
    public nodeDetails = {};
    public selectedNode = {};
    public featureDetails = {};
    public fromFeaturePage = false;
    public expandedNode: any = [];
    public parentNode = {};
    public isSelectedNodeExpanded = {};
    public subject = new Subject<any>();
    public featureExpansionSubject = new Subject<any>();
    public activeFeature: string = null;
    public featureDataChanged: boolean;
    public stepDataChanged: boolean;
    public nodeBeforeStepChange: any = [];
    public nodeBeforeFeatureChange: any = [];
    public childrenClone: any = [];
    public bluetoothIssueId: string = '';
    public featureName: string = '';
    public activeFeatureStatus: string = null;

    callrefreshFeatureTree(treeDetails: any) {
        this.subject.next({ treeDetails: treeDetails });
    }

    refreshFeatureTree(): Observable<any> {
        return this.subject.asObservable();
    }


    /** For service call to get flow
     * @class AdminService
     * @method getFlow
     * @param flowName - flow name
     * @returns Observable
     */
    getFlow(type?: string, division?: string, status?: string): Observable<any> {
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting flow', '');
        const selectedApplication = division ? division.toLowerCase() : this.selectedApplication.toLowerCase();
        let url: string = null;
        if (type) {
            url = this.baseURL['GET_ALL_FEATURE'] + '?source=' + selectedApplication + '&featureType=' +
                type + '&status=' + status + '&t=' + new Date().getTime();
        } else {
            url = this.baseURL['GET_ALL_FEATURE'] + '?source=' + selectedApplication + '&status=' + status + '&t=' +
                new Date().getTime();
        }
        return this.httpService.get(url).pipe(
            map((data: any) => {
                this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                    'Getting flow successful', JSON.stringify(data));

                data.sort(function(a,b){
                    return a.controls[0].featureName.localeCompare(b.controls[0].featureName, 'en', {'sensitivity': 'base'});
                });
                return data;
            }),
            catchError((error: any) => {
                this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                    'Getting flow failed', '', error);
                return error;
            })
        );
            // .map(
            //     (data: any) => {
            //         this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            //             'Getting flow successful', JSON.stringify(data));

            //         data.sort(function(a,b){
            //             return a.controls[0].featureName.localeCompare(b.controls[0].featureName, 'en', {'sensitivity': 'base'});
            //         });
            //         return data;
            //     },
            //     (error: any) => {
            //         this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            //             'Getting flow failed', '', error);
            //         return error;
            //     });
    }

    /** For service call to get flow
    * @class AdminService
    * @method getSubFlow
    * @param flowName - flow name
    * @returns Observable
    */
    getSubFlow(flowId: string): Observable<any> {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting flow', '');
        const url = this.baseURL['GET_FLOWS_BY_ID'] + '?issueId=' + flowId + '&source=' +
            selectedApplication + '&t=' + new Date().getTime();
        return this.httpService.get(url).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow successful', JSON.stringify(data));
                    return data;
                     } ),
               catchError ((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow failed', '', error);
                    return error;
                })
        );
    }


    /** For service call to get flow
  * @class AdminService
  * @method getSubFeatureFlow
  * @param flowId - flow id
  * @returns Observable
  */
    getSubFeatureFlow(flowId: string, division?: string): Observable<any> {
        const selectedApplication = division ? division.toLowerCase() : this.selectedApplication.toLowerCase();
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting flow', '');
        const url = this.baseURL['GET_SUBFEATURE_FLOW'] + '?issueId=' + flowId + '&source=' +
            selectedApplication + '&t=' + new Date().getTime();
        return this.httpService.get(url).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow successful', JSON.stringify(data));
                    return data;
            }),
             catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow failed', '', error);
                    return error;
                })
                );
    }

    /** For service call to get flow
     * @class AdminService
     * @method updateSubFeatureFlow
     * @param Flow Model -Flow Model
     * @returns Observable
     */
    updateSubFeatureFlow(flow: Flow): Observable<any> {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting flow', '');
        const url = this.baseURL['UPDATE_SUBFEATURE_FLOW'] + '?source=' + selectedApplication;
        return this.httpService.put(url, flow).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow failed', '', error);
                    return error;
                })
        );
    }

    /** For service call to get flow
   * @class AdminService
   * @method insertSubFeatureFlow
   * @param Flow Model -Flow Model
   * @returns Observable
   */
    insertSubFeatureFlow(flow: Flow): Observable<any> {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting flow', '');
        const url = this.baseURL['UPDATE_SUBFEATURE_FLOW'] + '?source=' + selectedApplication;
        return this.httpService.post(url, flow).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow successful', JSON.stringify(data));
                    return data;
                }),
                catchError(
                (error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow failed', '', error);
                    return error;
                })
                );
    }

    /** For service call to get flow
   * @class AdminService
   * @method insertSubFeatureFlow
   * @param Flow Model -Flow Model
   * @returns Observable
   */
    insertFeatureFlow(flow: Flow): Observable<any> {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;

        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting flow', '');
        const url = this.baseURL['UPDATE_SUBFEATURE_FLOW'] + '?source=' + selectedApplication;
        return this.httpService.post(url, flow).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow successful', JSON.stringify(data));
                    return data;
                }),
                catchError(
                (error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow failed', '', error);
                    return error;
                })
                );
    }

    /** For service call to inser document details
  * @class AdminService
  * @method insertdocument
  * @param document Model
  * @returns Observable
  */
    insertdocument(content: Content): Observable<any> {
        content.contentId = null;
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;

        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started inserting support Content', '');
        const url = this.baseURL['UPDATE_DOCUMENT'] + '?source=' + selectedApplication;
        return this.httpService.post(url, content).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'inserting support Content successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'inserting support Content failed', '', error);
                    return error;
                })
                );
    }

    /** For service call to inser document details
  * @class AdminService
  * @method insertdocument
  * @param document Model
  * @returns Observable
  */
    updateSupportContent(content: Content): Observable<any> {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started updating support Content', '');
        const url = this.baseURL['UPDATE_DOCUMENT'] + '?source=' + selectedApplication;
        return this.httpService.put(url, content).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'updating support Content successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'inserting support Content failed', '', error);
                    return error;
                })
                );
    }

    /** For service call to get document details
* @class AdminService
* @method insertdocument
* @param document Model
* @returns Observable
*/
    getAllDocuments(): Observable<any> {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;

        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting support Content', '');
        const url = this.baseURL['UPDATE_DOCUMENT'] + '?source=' + selectedApplication + '&contentType=document&t=' + new Date().getTime()
        return this.httpService.get(url).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting support content successful', JSON.stringify(data));
                    data.sort(function(a,b){
                        return a.document.fileDisplayName.localeCompare(b.document.fileDisplayName, 'en', {'sensitivity': 'base'});
                      });
                        return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting support content failed', '', error);
                    return error;
                })
        );
    }

    /** For service call to get document details
* @class AdminService
* @method insertdocument
* @param document Model
* @returns Observable
*/
    getAllResources(): Observable<any> {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting support Content', '');
        const url = this.baseURL['UPDATE_DOCUMENT'] + '?source=' + selectedApplication + '&contentType=resource&t=' + new Date().getTime()
        return this.httpService.get(url).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting support content successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting support content failed', '', error);
                    return error;
                })
        );
    }

    /** For service call to get disclaimer details
* @class AdminService
* @method insertdocument
* @param document Model
* @returns Observable
*/
    getAllDisclaimers(): Observable<any> {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting support Content', '');
        const url = this.baseURL['UPDATE_DOCUMENT'] + '?source=' + selectedApplication + '&contentType=disclaimer';
        return this.httpService.get(url).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting support content successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting support content failed', '', error);
                    return error;
                })
        );
    }

    /** For service call to get video details
* @class AdminService
* @method insertvideo
* @param video Model
* @returns Observable
*/
    getAllVideos(): Observable<any> {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting support Content', '');
        const url = this.baseURL['UPDATE_DOCUMENT'] + '?source=' + selectedApplication + '&contentType=video&t=' + new Date().getTime()
        return this.httpService.get(url).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting support content successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting support content failed', '', error);
                    return error;
                })
        );
    }


/** For service call to delete support Content details
* @class AdminService
* @method delete support content
* @param content Id
* @returns Observable
*/
    deleteContentById(id: string): Observable<any> {
        const url = this.baseURL['UPDATE_DOCUMENT'] + '?contentId=' + id;
        return this.httpService.delete(url).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Deleting support content successful', JSON.stringify(data));
                    return data;
                }),catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Deleting support content failed', '', error);
                    return error;
                })
                );
    }

    /** For service call to delete support Content details
    * @class AdminService
    * @method delete support content
    * @param content Id
    * @returns Observable
    */
    deleteFeaturesInBulk(features): Observable<any> {
    const url = this.baseURL['DELETE_FEATURES'];
    return this.httpService.post(url ,features).pipe(
        map(
            (data: any) => {
                this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                    'Deleting support content successful', JSON.stringify(data));
                return data;
            }),
            catchError((error: any) => {
                this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                    'Deleting support content failed', '', error);
                return error;
            })
            );
}



    /** For service call to get flow
  * @class AdminService
  * @method insertSubFeatureFlow
  * @param Flow Model -Flow Model
  * @returns Observable
  */
    deleteFeatureFlow(issueId: string): Observable<any> {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting flow', '');
        const url = this.baseURL['DELETE_FEATURE_FLOW'] + '?source=' + selectedApplication + '&issueId=' + issueId;
        return this.httpService.delete(url).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow failed', '', error);
                    return error;
                })
                );
    }

    /** For service call to get flow
     * @class AdminService
     * @method deleteSubFeatureFlow
     * @param FlowId  -FlowId
     * @returns Observable
     */
    deleteSubFeatureFlow(flowId: string): Observable<any> {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting flow', '');
        const url = this.baseURL['UPDATE_SUBFEATURE_FLOW'] + '?source=' + selectedApplication;
        return this.httpService.put(url).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow successful', JSON.stringify(data));
                    return data;
                }),
                catchError(
                (error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow failed', '', error);
                    return error;
                })
                );
    }

    /** For service call to get flow
     * @class AdminService
     * @method deleteImage
     * @param FlowId  -FlowId
     * @returns Observable
     */
    deleteImage(image): Observable<any> {
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting flow', '');
        const url = this.baseURL['DELETE_IMAGE'];
        return this.httpService.delete(url + '?fileName=' + image).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow failed', '', error);
                    return error;
                })
                );
    }

    /** For service call to get All Tag Name
   * @class AdminService
   * @method getAllTagName
   * @returns Observable
   */
    getAllTagName(): Observable<any> {
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting flow', '');
        const url = this.baseURL['GET_ALL_TAGNAME'] + '?source=' + this.selectedApplication;
        return this.httpService.get(url).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow failed', '', error);
                    return error;
                })
        );
    }

    /** For service call to upload images to S3
     * @class AdminService
     * @method uploadImage
     * @param flowName - flow name
     * @returns Observable
     */
    uploadImage(imageRequestBody) {
        const url = this.appBase.Urls.IMAGE_UPLOAD;
        return this.httpService.post(url, imageRequestBody).pipe(
            map((response: any) => {
                const contentData: ContentData = {
                    url: JSON.parse(response).url,
                    path: encodeURIComponent(JSON.parse(response).path)
                };
                return contentData;
            })
            );
    }

    uploadtoS3(imageRequestBody, url, type) {
        this.loaderService.show();
        // Add Content-Type Header Info
        const header = new HttpHeaders();
        header.append('Content-Type', type);
        return this.http.put(url, imageRequestBody, { headers: header }).pipe(
            map((response: any) => {
                this.loaderService.hide();
                return response;
            })
            );
    }

    /** For service call to upload videos to S3
    * @class AdminService
    * @method uploadVideo
    * @param flowName - flow name
    * @returns Observable
    */
    uploadVideo(videoRequestBody) {
        const url = this.appBase.Urls.VIDEO_UPLOAD;
        return this.httpService.post(url, videoRequestBody).pipe(
            map((response: any) => {
                return response;
            })
            );
    }

    /** For service call to get All Tag Name for Feature
       * @class AdminService
       * @method getStepsByFeature
       * @returns Observable
       */
    getStepsByFeature(featureId: string, division?: string): Observable<any> {
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting flow', '');
        const selectedApplication = division ? division.toLowerCase() : this.selectedApplication.toLowerCase();
        const url = this.baseURL.GET_TAGS_BY_FEATURE + '?source=' + selectedApplication + '&issueId=' + featureId;
        return this.httpService.get(url).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow successful', JSON.stringify(data));
                    return data;
                }),catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting flow failed', '', error);
                    return error;
                })
        );
    }

    isS3FileExist(imageRequestBody): Observable<any> {
        const url = this.baseURL['CHECK_S3_FILE'];
        return this.httpService.post(url, imageRequestBody).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd('File upload check', 'Upload image/video flow',
                        'Getting file check successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException('File upload check', 'Upload image/video flow',
                        'Getting file check failed', '', error);
                    return error;
                })
                );
    }

    getDisclaimers() {
        return this.httpService.get('./assets/data/admin/disclaimer.json').pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd('File upload check', 'Upload image/video flow',
                        'Getting file check successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException('File upload check', 'Upload image/video flow',
                        'Getting file check failed', '', error);
                    return error;
                })
        );
    }

    
    updateStatus(feature) {
        const url = this.baseURL['UPDATE_FEATURE_STATUS'];
        return this.httpService.put(url, feature).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd('Feature Status', 'Feature status update', 'status update successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException('Feature Status', 'Feature status update', 'status update failed', '', error);
                    return error;
                })
                );
    }
    /** For service call to copy feature
     * @class AdminService
     * @method copyFeature
     * @param featureIssueId
     * @returns Observable
     */

    copyFeature(featureIssueId: string, type?: string, user?: string, name?: string , division?:string, crossDivisionCopy?:boolean): Observable<any> {
        const flow = <Flow>(
            {
                tagName: null, informationOrQuestion: null, issueId: null, controls: [],
                targetId: null, imagesOrVideos: [], type: null, notes: null, lastModifiedDate: null, isLastStep: null
            });
        flow.issueId = featureIssueId;
        const request = {
            issueId: featureIssueId,
            source: crossDivisionCopy ? division : this.selectedApplication.toLowerCase(),
            selectedDivision: this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication,
            featureType: '',
            destFeatureType: type,
            destFeatureName: name,
            user: user
        };

        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting flow', '');

        const url = this.baseURL['COPY_FEATURE'];
        return this.httpService.put(url, request).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Feature copy successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Feature copy failed', '', error);
                    return error;
                })
                );
    }

    getAllErrorMessages() {
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting Error Messages', '');
        const url = this.baseURL['GET_ERROR_MESSAGES'];
        return this.httpService.get(url).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting Error Messages successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting Error Messages failed', '', error);
                    return error;
                })
        );
    }

    createErrorMessages(errorMessage) {
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started inserting Error Messages', '');
        const url = this.baseURL['GET_ERROR_MESSAGES'];
        return this.httpService.post(url + '/' + errorMessage.code + '/' + errorMessage.platform, errorMessage).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Inserting Error Messages successful', JSON.stringify(data));
                    return data;
                }),
               catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Inserting Error Messages failed', '', error);
                    return error;
                })
                );
    }

    updateErrorMessages(errorMessage) {
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started updating Error Guide', '');
        const url = this.baseURL['GET_ERROR_MESSAGES'];
        return this.httpService.post(url + '/' + errorMessage.platform + '/' + errorMessage.code, errorMessage).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Updating Error Guide successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Updating Error Guide failed', '', error);
                    return error;
                })
                );
    }

    getCategoryMappingOrder() {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;

        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started getting Error Messages', '');
        const url = this.baseURL.CATEGORY_MAPPING;
        return this.httpService.get(url + '?source=' + selectedApplication).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting Error Messages successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Getting Error Messages failed', '', error);
                    return error;
                })
        );
    }


    updateCategoryMappingOrder(requestParameter) {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;
        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started updating Error Guide', '');
        const url = this.baseURL.CATEGORY_MAPPING;
        return this.httpService.put(url + '?source=' + selectedApplication, requestParameter).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Updating Error Guide successful', JSON.stringify(data));
                    return data;
                }),
                catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Updating Error Guide failed', '', error);
                    return error;
                })
                );
    }

    deleteCategoryMappingOrder(issueId) {
        const selectedApplication = this.selectedApplication ? this.selectedApplication.toLowerCase() : this.selectedApplication;

        this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Started updating Error Guide', '');
        const url = this.baseURL.CATEGORY_MAPPING;
        return this.httpService.delete(url + '?source=' + selectedApplication + '&issueId=' + issueId).pipe(
            map(
                (data: any) => {
                    this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Updating Error Guide successful', JSON.stringify(data));
                    return data;
                }),
               catchError((error: any) => {
                    this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
                        'Updating Error Guide failed', '', error);
                    return error;
                })
                );
    }


}
